import type { TableInformation } from '../../../config/flavourConfig';
import type { CarDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/mvp';
import type {
    TermDTO,
    CoverableDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { getDogInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/dogCoverableDetailsInsuranceSumsConfig';
import { getCatInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/catCoverableDetailsInsuranceSumsConfig';
import { getKennelInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/kennelCoverableDetailsInsuranceConfig';
import { getAdultAccidentInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/adultAccidentCoverableDetailsInsuranceSumsConfig';
import { getYoungAccidentInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/youngAccidentCoverableDetailsInsuranceSumsConfig';
import { getChildAccidentInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/childAccidentCoverableDetailsInsuranceSumsConfig';
import { getYouthContentInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/youthContentCoverableDetailsInsuranceSumsConfig';
import { getPrivateContentInsuranceSumsCoverableDetailsConfig } from './LoBInsuranceSumsConfig/privateContentCoverableDetailsInsuranceSumsConfig';
import { getPrivateCarInsuranceSumsCoverableDetailsConfig } from '../../ShoppingBasketPage/utils/ShoppingBasketInsuranceSumsUtil';

const getInsuranceSumsCoverableDetailsConfig = (
    coverable: CoverableDTO
): TableInformation | undefined => {
    switch (coverable.flavourName) {
        case 'Hundeforsikring':
            return getDogInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Katteforsikring':
            return getCatInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Kennelforsikring':
            return getKennelInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Ulykkesforsikring':
            return getAdultAccidentInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Ulykkesforsikring til unge':
            return getYoungAccidentInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Børneforsikring':
            return getChildAccidentInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Indboforsikring til unge':
            return getYouthContentInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Indboforsikring':
            return getPrivateContentInsuranceSumsCoverableDetailsConfig(coverable);
        case 'Bilforsikring':
            return getPrivateCarInsuranceSumsCoverableDetailsConfig(coverable as CarDTO);
        default:
            return undefined;
    }
};

const getCoverageTermValue = (
    coverable: CoverableDTO,
    coverageType: string,
    termId: string
): string => {
    return (
        coverable.coverages
            ?.find((coverage) => coverage.type === coverageType)
            ?.terms?.find((term: TermDTO) => term.publicId === termId)?.value ?? ''
    );
};

const formatAmountToDK = (amount: string): string => {
    return parseInt(amount).toLocaleString('da-DK');
};

const formatAmountWithCurrency = (amount: string): string => {
    return amount?.concat(' kr.');
};

const isCoverageSelected = (coverable: CoverableDTO, coverageType: string): boolean => {
    return (
        coverable.coverages?.find((coverage) => coverage.type === coverageType)?.selected ?? false
    );
};

export {
    getInsuranceSumsCoverableDetailsConfig,
    getCoverageTermValue,
    formatAmountToDK,
    formatAmountWithCurrency,
    isCoverageSelected
};
